(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(() => {
  function syncSportsProductAppContext() {
    const root = document.documentElement;
    const page = new URL(location.href);
    const native = /FoxAppy/i.test(navigator.userAgent) ||
      !!(window.ReactNativeWebView || window.CustomerOrdersWebView || window.FoxAppyMenuVisibility) ||
      document.cookie.split(';').some(value => value.trim() === 'foxappy_app=1') ||
      root.classList.contains('in-native-app') ||
      page.searchParams.get('app') === 'foxappy' || page.searchParams.get('origin') === 'mobile';
    root.classList.toggle('sports-native-product', native);
  }
  syncSportsProductAppContext();
  window.addEventListener('pageshow', syncSportsProductAppContext);
  document.addEventListener('DOMContentLoaded', syncSportsProductAppContext, { once: true });
  document.addEventListener('shopify:section:load', syncSportsProductAppContext);
})();

  } catch(e) { console.error(e); }
})();
})();
